export default function script_hero() {
  $(window).on('load', function(){     //ページ内のすべての要素が読み込まれた後に動作を行う
    setTimeout(function(){  //すべての要素が読み込まれた後0.5秒後にスタート
      $(".Load").fadeOut("slow");  //ロード幕のフェードアウト
  
      const firstviewWrap = $('#firstviewWrap'),     //firstviewWrap要素を変数に入れる
            firstviewBack = $('#firstviewBack'),     //firstviewBack要素を変数に入れる
            firstviewBackImg = firstviewBack.children('img'),     //firstviewBack要素の子のimg要素を変数に入れる
            titlePageH2 = $('.Hero__titlePageH2'),     //ロゴ
            titlePageText = $('.Hero__titlePageText'),     //ページタイトル
            titlePageScroll = $('.Hero__titlePageScroll'),   //SCROLL文字
            titlePageScrollArrow = $('.Hero__titlePageScrollArrow'),   //SCROLL矢印
            fadeSpeed = 1000,     //フェードスピード
            switchDelay = 3800,     //切り替える時間
            switchPoint = 601,
            imgRatio = firstviewBackImg.width() / firstviewBackImg.height();     //縦横比
  
      function firstviewFit(){
        var wdWidth = window.innerWidth,     //ウィンドウの横幅を取得
            wdHeight = window.innerHeight,     //ウィンドウの高さを取得
            heroHeight = wdHeight - 70,     //ウィンドウの高さからヘッダーの高さを引く
            setHeight = wdWidth / imgRatio,
            scrollTop = $(window).scrollTop();  //ブラウザのスクロール位置を取得

        if(scrollTop === 0) {  //ブラウザのスクロール位置が0の時だけリサイズ処理を行う
          if(setHeight < heroHeight){
            setHeight = window.innerHeight - 70;
            wdWidth = setHeight * imgRatio;
          }
          firstviewWrap.css({height: wdHeight-70});     //ウィンドウの高さをfirstviewWrap要素に設定
          firstviewBackImg.css({marginTop: Math.round(-setHeight/2), marginLeft: Math.round(-wdWidth/2), width: wdWidth, height: setHeight});     //画像の位置設定
        }
      }
  
      jQuery(window).on('resize', function(){
        firstviewFit();     //リサイズされた時にfirstviewFit関数実行
      });

      $(window).scrollTop(0);  //ページロード（更新）時にブラウザのスクロール位置を0にする
      firstviewFit();     //ページロード時に一度firstviewFit関数実行
  
      //最初の画像を表示（スライドなし）
      firstviewBackImg.css({visibility: 'visible', opacity: '0'}).first().stop().animate({opacity: '1'}, fadeSpeed);
  
      //タイトルフェードイン
      titlePageH2.addClass("Hero__titlePageH2--animated");
      titlePageText.addClass("Hero__titlePageText--animated");
      titlePageScroll.addClass("Hero__titlePageScroll--animated");
      titlePageScrollArrow.addClass("Hero__titlePageScrollArrow--animated");
  
    }, 500);
  });
}
